import { ADD_KUOBZ, CLEAR_KUOBZES, INIT_KUOBZES, UPDATE_SINGLE_KUOBZ } from '../type';

export function kuobzReducer(state = [], action) {
  const { type, payload } = action;

  switch (type) {
    case INIT_KUOBZES: {
      // Добавляем элементы к существующему состоянию
      return [...state, ...payload];
    }
    case ADD_KUOBZ: {
      return [...payload, ...state];
    }

    case UPDATE_SINGLE_KUOBZ: {
      const { kuobzId, data } = payload;
      return state.map((kuobz) => {
        if (kuobz.id === Number(kuobzId)) {
          return { ...kuobz, ...data }; // обновляем только переданные поля
        }
        return kuobz;
      });
    }
    case CLEAR_KUOBZES: {
      return payload;
    }
    default:
      return state;
  }
}
